import { ConfirmDestructiveDialog } from '@/shared/components/ConfirmDestructiveDialog';

/**
 * Confirms removing one entry.
 *
 * Names the key rather than asking "are you sure?", and says the value cannot be
 * recovered — because it cannot: the service keeps no history and, for a secret,
 * nobody can read the value first to write it down. Purely presentational; the
 * page owns which entry is pending, what confirming does, and the refusal (e.g.
 * still referenced by an LLM profile's credential override, 067 FR-010) shown
 * inside it.
 */
export function DeleteSecretDialog({
  entryKey,
  open,
  isPending,
  error,
  onConfirm,
  onCancel,
}: {
  entryKey: string;
  open: boolean;
  isPending: boolean;
  error?: string | null;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  return (
    <ConfirmDestructiveDialog
      open={open}
      title={<>Delete &ldquo;{entryKey}&rdquo;?</>}
      confirmLabel="Delete secret"
      isPending={isPending}
      error={error}
      onConfirm={onConfirm}
      onCancel={onCancel}
    >
      This removes &ldquo;{entryKey}&rdquo; from this workspace and from every
      task that runs in it. The stored value cannot be recovered.
    </ConfirmDestructiveDialog>
  );
}
